import React from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Tooltip, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const RadioLabel = ({ label, tooltip, tooltipIconSx, description }) => {
  const labelContent =
    typeof label === 'string' ? (
      <Typography variant="h6" fontWeight="bold" textTransform="uppercase">
        {label}
      </Typography>
    ) : (
      label
    )

  if (!tooltip && !description) {
    return labelContent
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {labelContent}
        {tooltip && !description && (
          <Tooltip title={tooltip} arrow>
            <InfoOutlinedIcon fontSize="small" color="action" sx={tooltipIconSx} />
          </Tooltip>
        )}
      </Box>
      {description && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
          {tooltip && (
            <Tooltip title={tooltip} arrow>
              <InfoOutlinedIcon fontSize="small" color="action" sx={tooltipIconSx} />
            </Tooltip>
          )}
        </Box>
      )}
    </Box>
  )
}

RadioLabel.propTypes = {
  label: PropTypes.node.isRequired,
  tooltip: PropTypes.string,
  tooltipIconSx: PropTypes.object,
  description: PropTypes.string,
}

const OnOffRadioGroup = ({
  value,
  onChange = noop,
  onLabel,
  offLabel,
  onDescription,
  offDescription,
  onTooltip,
  offTooltip,
  onTooltipIconSx,
  offTooltipIconSx,
  disabled = false,
  formControlSx = { display: 'block' },
  labelSx,
}) => (
  <FormControl component="fieldset" sx={formControlSx}>
    <RadioGroup row value={value} onChange={onChange}>
      <FormControlLabel
        value="true"
        disabled={disabled}
        control={<Radio size="small" />}
        sx={labelSx}
        label={<RadioLabel label={onLabel} tooltip={onTooltip} tooltipIconSx={onTooltipIconSx} description={onDescription} />}
      />
      <FormControlLabel
        value="false"
        disabled={disabled}
        control={<Radio size="small" />}
        sx={labelSx}
        label={<RadioLabel label={offLabel} tooltip={offTooltip} tooltipIconSx={offTooltipIconSx} description={offDescription} />}
      />
    </RadioGroup>
  </FormControl>
)

OnOffRadioGroup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onLabel: PropTypes.node.isRequired,
  offLabel: PropTypes.node.isRequired,
  onDescription: PropTypes.string,
  offDescription: PropTypes.string,
  onTooltip: PropTypes.string,
  offTooltip: PropTypes.string,
  onTooltipIconSx: PropTypes.object,
  offTooltipIconSx: PropTypes.object,
  disabled: PropTypes.bool,
  formControlSx: PropTypes.object,
  labelSx: PropTypes.object,
}

export default OnOffRadioGroup
